module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_8-34946d99b73ae0c60604476d411a5529.png";